import React from 'react';
import * as Antd from 'antd';
import { ArrowBack } from '@mui/icons-material';

const Steps = ({ step, steps, setStep, children, isGoBack = false }) => {

    const [Steps, setSteps] = React.useState([]);
    const [total, setTotal] = React.useState(0);

    React.useEffect(() => {
        setSteps([]);
        const ss = [];
        for (var s = 0; s < steps.length; s++) {
            let c = ss[s - 1]?.current || s;
            if (ss.find(sss => sss.label.toLowerCase() === steps[s].toLowerCase())) {
                ss.push({ label: steps[s], show: false, current: c, });
            } else {
                ss.push({ label: steps[s], show: true, current: c + 1, });
            }
        }
        setSteps(ss);
        setTotal(ss.filter(x => x.show).length);
    }, [steps]);

    const s = step - 1;

    const goBack = () => {
        setStep(pstep => (pstep - 1));
    }

    return (
        <React.Fragment>
            <div id="Steps" className="flex">
                <div className="step-left bg-white flex-none w-96">
                    <div className="flex justify-center items-center h-4/5">
                        <div>
                            <div className="mb-8">Etape {step || 0} sur {total}</div>
                            <Antd.Steps direction="vertical" size="small" current={(Steps[s] || { current: 1 }).current - 1}>
                                {Steps.map(Step => (
                                    Step.show && <Antd.Steps.Step key={Step.label} title={Step.label} />
                                ))}
                            </Antd.Steps>
                        </div>
                    </div>
                </div>
                <div className="step-right flex-1">
                    <div className="mt-8" />
                    <div style={{ width: '80%', margin: '0 auto' }}>
                        {isGoBack && <h2 className="text-xl font-bold pointer mb-12" onClick={goBack}>
                            <ArrowBack /> {steps[s]}
                        </h2>
                        }
                        {children}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Steps;